// extracted by mini-css-extract-plugin
export default {"badge":"UnseenDot-index__badge--uzRZ2"};